import { withAuth } from "@/hoc/withAuth";
import { AppRoutes } from "@/routes/config";
import { logout } from "@/utils/logout";
import { createUrlWithParams } from "@/utils/url";
import { useLayoutEffect } from "react";

const Logout = () => {
  useLayoutEffect(() => {
    const handleLogout = async () => {
      const { email, externalId } = await logout();
      const url =
        externalId && email
          ? createUrlWithParams(AppRoutes.loginCredentials, { externalId, email })
          : createUrlWithParams(AppRoutes.login, { externalId });
      globalThis.location.replace(url);
    };

    handleLogout();
  }, []);

  return null;
};

export default withAuth(Logout);
